<progressbar class="progress-striped" [max]="max" [value]="value"> </progressbar>
